import type { ReactNode } from 'react';
import type { FileRequest } from '@/types/api';
import { EmptyState } from '@/components/ui/EmptyState';
import { RequestCard } from './RequestCard';

interface RequestListProps {
  requests: FileRequest[];
  emptyAction?: ReactNode;
  emptyDescription?: string;
}

export function RequestList({ requests, emptyAction, emptyDescription }: RequestListProps) {
  if (requests.length === 0) {
    return (
      <EmptyState
        title="No requests"
        description={emptyDescription ?? 'You have no matching requests.'}
        action={emptyAction}
      />
    );
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
      {requests.map((r) => (
        <RequestCard key={r.id} request={r} />
      ))}
    </div>
  );
}
